
export default function getThumbUrl(path) {
	return `${process.env.DAISY_CMS_URL}/thumbs${path}`
}